/**
 * `/changes` action (BL-0129): the newest documents in this archive by DOE
 * issue date, straight from the Plone catalog. The query lives in
 * `components/Changes/describe.js`, shared with the RSS feed.
 */
import { CHANGES_QUERY } from '../components/Changes/describe';

export const GET_CHANGES = 'GET_CHANGES';

export function getChanges() {
  return {
    type: GET_CHANGES,
    request: { op: 'get', path: CHANGES_QUERY },
  };
}

export default getChanges;
